module.exports = __webpack_public_path__ + "img/poisoner.44c80b94.png";